import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Delete({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Delete</title>
      <path
        d="M10 11V17"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11V17"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 7H20"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7V6.25C5.58579 6.25 5.25 6.58579 5.25 7H6ZM18 7H18.75C18.75 6.58579 18.4142 6.25 18 6.25V7ZM17.25 7V18H18.75V7H17.25ZM15 20.25H9V21.75H15V20.25ZM6.75 18V7H5.25V18H6.75ZM6 7.75H12V6.25H6V7.75ZM12 7.75H18V6.25H12V7.75ZM9 20.25C7.75736 20.25 6.75 19.2426 6.75 18H5.25C5.25 20.0711 6.92893 21.75 9 21.75V20.25ZM17.25 18C17.25 19.2426 16.2426 20.25 15 20.25V21.75C17.0711 21.75 18.75 20.0711 18.75 18H17.25Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
